module.exports = __webpack_public_path__ + "static/media/CT_2019_30439A_pdf.bf95d40a.pdf";